import { Component, OnInit } from '@angular/core';
import { ObjectivesService } from '../objectives.service';

@Component({
  selector: 'cv-objective-landing',
  templateUrl: './objective-landing.component.html',
  styleUrls: ['./objective-landing.component.scss']
})
export class ObjectiveLandingComponent implements OnInit {
    //TODO: fix search debounce

    filterText: string = "";

    constructor(
        public objectiveService: ObjectivesService,
    ) {}

    async ngOnInit() {
        // Loads the left box items
        this.objectiveService.LoadGroupTypes();
        this.objectiveService.LoadColorPalettes();
        this.objectiveService.LoadObjectives();
    }

    clearSearch() {
        this.filterText = "";
    }

    applyFilter() {}

    updateTabSelected(str:string) {
        if (str == "metric") {
            this.objectiveService.showLandingMetricTab = true;
            this.objectiveService.showLandingGroupsTab = false;
        }
        else if (str == "groups") {
            this.objectiveService.showLandingMetricTab = false;
            this.objectiveService.showLandingGroupsTab = true;
        }

        this.filterText = "";
    }

    scrollToTop() {
        //Force a scroll to the top of the page since scrolling on configure pages causes odd scrolling
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }

    clickNew() {
        this.scrollToTop();

        this.objectiveService.showAddEditObjective = true;

        this.objectiveService.addEdit.originalObjectives = [];
        this.objectiveService.addEdit.editedObjectives = [];
        this.objectiveService.addNewObjective(0, 0);
        this.objectiveService.addEdit.selectedObjective = 0;
        this.objectiveService.addEdit.assignedGroups = [];
        this.objectiveService.addEdit.originalAssignedGroups = [];
        this.objectiveService.addEdit.MetricID = 0;
        this.objectiveService.addEdit.MetricName = "";
        this.objectiveService.addEdit.MetricValueType = null;
        this.objectiveService.addEdit.MetricObjectiveType = null;
        this.objectiveService.addEdit.MetricValueTimeType = null;
        this.objectiveService.addEdit.MetricDirection = null;
        this.objectiveService.addEdit.MetricIsRealtime = null;
        this.objectiveService.addEdit.selectedRange = null;

        this.objectiveService.showLandingHeader = false;

        if (this.objectiveService.showLandingMetricTab) {
            this.objectiveService.showMetricCardView = true;
            this.objectiveService.showMetricSelectView = false;
        }
    }
}
